import { render, staticRenderFns } from "./BookingFlightPartDetail.vue?vue&type=template&id=3dbd2f5a&scoped=true&"
import script from "./BookingFlightPartDetail.vue?vue&type=script&lang=js&"
export * from "./BookingFlightPartDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookingFlightPartDetail.vue?vue&type=style&index=0&id=3dbd2f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd2f5a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbd2f5a')) {
      api.createRecord('3dbd2f5a', component.options)
    } else {
      api.reload('3dbd2f5a', component.options)
    }
    module.hot.accept("./BookingFlightPartDetail.vue?vue&type=template&id=3dbd2f5a&scoped=true&", function () {
      api.rerender('3dbd2f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/FlightDetails/BookingFlightPartDetail.vue"
export default component.exports